import { useEffect } from 'react';

/** Hook for changing title of browser tab*/
export const usePageTitle = (title?:string) => {
  useEffect(() => {
    title && (document.title = title);
  }, [title]);
};